import React from "react";
import GameSsoLoginCallBack from "Utils/GameSsoLoginCallBack";
import { useLocation } from "react-router-dom";
import AppSsoLoginCallBack from "Utils/AppSsoLoginCallBack";


const AppSsoCallBackKakao = () => {
    const location= useLocation();  
    const serchParamsFunc = () => {
        return new URLSearchParams(location.search);
    }
    let query =serchParamsFunc();
    let getGameSvcCd = query.get("gameSvcCd");
    let redirectUri = query.get("redirectUri");
    AppSsoLoginCallBack("kakao",getGameSvcCd,redirectUri);
    return(
        <></>
    )
}

export default AppSsoCallBackKakao;